import React from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdDelete } from "react-icons/md";
import moment from "moment";
import { ModalHeader, ModalRow, ModalRowValue, ModalSection, ModalSectionTitle, ScrollableContent } from "../Styles/InputStyles";
import { getModeName } from "../../helpers";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const ViewDetails = ({
    setIsViewExpense,
    selectedData,
}) => {

    const onClose = () => {
        setIsViewExpense(false);
    };

    return (
        <Container>
            <ModalHeader>
                <Title>Expense Details</Title>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <ProfileSection className="flex justify-between">
                <UserInfo>
                    <span className="font-medium mb-0">₹{selectedData?.amount}</span>
                    <span className="text-sm text-gray-600">{selectedData?.name}</span>
                </UserInfo>

            </ProfileSection>
            <Content>
                <ScrollableContent>
                    <Wrapper>
                        <BtnWrapper>
                            <ModalSectionTitle>Transaction Details</ModalSectionTitle>

                        </BtnWrapper>
                        <ModalSection>
                            <ModalRow>
                                <FlexCol >
                                    <LabelShow>Amount Paid</LabelShow>
                                    <ModalRowValue>₹{selectedData?.amount}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Payment Mode</LabelShow>
                                    <ModalRowValue>{getModeName(selectedData?.paymentMethod)}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Date</LabelShow>
                                    <ModalRowValue>
                                        {moment(selectedData.paidDate).format("DD-MMM-YY")}
                                    </ModalRowValue>
                                </FlexCol>
                                <FlexCol className="mb-3">
                                    <LabelShow>Paid By</LabelShow>
                                    <ModalRowValue>{selectedData?.paidByName}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                        </ModalSection>

                        <BtnWrapper>
                            <ModalSectionTitle>Expense Details</ModalSectionTitle>
                        </BtnWrapper>
                        <ModalSection>
                            <ModalRow className="mb-3">
                                <FlexCol>
                                    <LabelShow>Paid To</LabelShow>
                                    <ModalRowValue>{selectedData?.paidToName}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Property</LabelShow>
                                    <ModalRowValue>{selectedData?.propName}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                            <div>
                                <FlexCol>
                                    <LabelShow>Description</LabelShow>
                                    <ModalRowValue>{selectedData?.description}</ModalRowValue>
                                </FlexCol>
                            </div>
                            <div className="flex justify-end">
                                <FlexCol>
                                    {/* <Label>Document</Label> */}
                                    <ModalRowValue className="text-blue-500 underline">
                                        <Link
                                            to={selectedData?.supportDoc}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {selectedData?.supportDoc?.split("/").pop()}
                                        </Link>
                                    </ModalRowValue>
                                </FlexCol>
                            </div>
                        </ModalSection>
                    </Wrapper>
                </ScrollableContent>
            </Content>
        </Container>
    );
};

const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const Section = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const Row = tw.div`grid grid-cols-2 py-1 md:p-1`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-600 text-md`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const LabelShow = tw.label`text-sm text-gray-400 font-normal`;
export default ViewDetails;
